import { FullscreenAdPopup, TravelService } from '@techminds/ad-banner';
import useTravelUser from 'hooks/useTravelUser';
import useUnpaidPaypoints from 'hooks/useUnpaidPaypoints';

export const POPUP_AD_ROOT_ELEMENT_CLASS_NAME =
  'POPUP_AD_ROOT_ELEMENT_CLASS_NAME';

const PopupAd = () => {
  const { nickName, coupons, isBiztripUser } = useTravelUser();
  const { loading, unpaidPaypoints } = useUnpaidPaypoints();

  if (!nickName || loading) {
    return null;
  }

  return (
    <FullscreenAdPopup
      service={TravelService.FLIGHT}
      nickname={nickName}
      coupons={!!coupons?.length}
      unpaidPaypoints={!!unpaidPaypoints}
      isBiztripUser={!!isBiztripUser}
    />
  );
};

export default PopupAd;
